export const PROJECT_CONSTS = {
    GET_PROJECTS: "GET_PROJECTS",
    GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
    UPDATE_PROJECT_BY_ID: "UPDATE_PROJECT_BY_ID",

    DELETE_PROJECT_BLOCK_BY_ID: "DELETE_PROJECT_BLOCK_BY_ID",
};
